<script setup lang="ts">
import AppContent from '@/components/app/AppContent.vue'
</script>

<template>
  <v-app>
    <Suspense>
      <template #default>
        <AppContent />
      </template>
      <template #fallback>
        <div class="d-flex flex-column justify-center align-center fill-height">
          <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
          <div class="mt-4 text-h6">Loading SIM...</div>
          <div class="text-body-2 text-medium-emphasis">
            Please wait while we start the application
          </div>
        </div>
      </template>
    </Suspense>
  </v-app>
</template>
<style lang="scss">
// the main file that imports everything related with styles
@use '/src/scss/settings.scss';
</style>
